$(document).ready(function() {
	var parent_node = document.querySelectorAll('.C0082');
	if(!parent_node) return false;
	
	function C0082(){
		var component = C0082.prototype;
		component.obj = {
			elem : {
				slider : null
			},
			option : {
				slide : {
					infinite: false,
					listStyle: true, //LGEGMO-5525 add
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows : true,
					dots: false,
					responsive : [
						{
							breakpoint : 767,
							settings : {
								arrows : false,
								dots: true
							}
						}
					]
				}
			}
		}
		component.init = function(){
			this.addEvent();
		}
		component.addEvent = function(){
			// DOM branch
			for(var a=0; a<parent_node.length; a++){
				var _this =  parent_node[a], 
					$this = $(_this);				
				for( var b=0; b<$this.length; b++ ){
					// event;
					this.slot($this);
					this.slide_generator( $this.find(".product-contents-cluster.on").children() );
				}
			}
		}
		component.slide_generator = function(slider){
			if( slider.hasClass("slick-initialized") ){
				slider.slick("setPosition");
			}else{
				slider.slick(component.obj.option.slide);
			}
		}
		component.slot = function(selector){
			var el = selector;
			var options = {
				syncGroup : [
					[".list-slot-item", "active"],
					[".product-contents-cluster", "on"],
					[".btn-tab", "active"]
				],
				fullLength : el.find(".slot-belt").children().length,
				showLength : 6,
				activeIndex : 0,
				itemMargin : 0,
				areaPadding : (30+11+35),
				avg : 0,
				positionY : 0,
				rollDistace : 0,
				cutoff : 0,
				limit : {
					min : 0,
					max : 0
				}
			}
			// init
			preset();
			reflowEvent();
			UIEvent();

			// methods
			function calcHeight(){
				var extract = el.find(".category-product-contents").outerHeight(true);
				el.find(".list-slot-package").css({
					height : (extract - (options.areaPadding*2)) + "px"
				})

				options.avg = Math.ceil(el.find(".list-slot-package").height()/2);
				options.itemMargin = Number(window.getComputedStyle( document.querySelector(".list-slot-item"), null ).getPropertyValue("margin-top").split("px")[0])
				options.limit.max = Number( (el.find(".slot-belt").outerHeight(true) + options.itemMargin) - (options.avg)*2);
				options.cutoff = Number( el.find(".slot-belt").outerHeight(true) - options.avg );

				return(options.avg, options.limit.max, options.itemMargin, options.cutoff);
			}
			function positioning(posY){
				var midline = options.avg - (options.itemMargin*2);

				posY = Math.ceil(el.find(".list-slot-item").eq(options.activeIndex).position().top);
				
				options.rollDistace = -(posY - midline);
				
				if( Math.abs(posY) < options.avg ){
					options.rollDistace = options.limit.min
				} else if( Math.abs(posY) >= options.cutoff ) {
					options.rollDistace = -(options.limit.max)
				}

				options.positionY = posY;

				return(options.positionY, options.rollDistace);
			}
			function slotAnimate(distance){
                el.find(".slot-belt").css({
                    transform : "translateY(" + distance + "px)"
				})

				options.rollDistace = distance;

				return(options.rollDistace);
            }
			function watchIndex(element){
				options.activeIndex = element.parent('li').index(); /* PJTWAUS-1 : 20200115 add */

				for(var i=0; i<options.syncGroup.length; i++){
					el.find(options.syncGroup[i][0]).removeClass(options.syncGroup[i][1]);
					el.find(options.syncGroup[i][0]).eq(options.activeIndex).addClass(options.syncGroup[i][1]);
				}
				/* LGEGMC-243 20200520 modify */
				el.find('.list-slot-item').attr({'aria-selected': false, 'tabindex': -1 });
				el.find('.list-slot-item').eq(options.activeIndex).attr({'aria-selected': true, 'tabindex': 0 });
				/*// LGEGMC-243 20200520 modify */				
				component.slide_generator( el.find(".product-contents-cluster").eq(options.activeIndex).children() );
			}
			function disableHandler(){
				if(options.fullLength <= options.showLength ){
					el.find(".slot-handler").addClass("disabled");
				}
			}
			function disabledrolling(){
				el.find(".slot-handler").find("button").removeClass("disabled");
				/* LGEGMC-243 20200528 */
				var $activeLi =  el.find(".category-list-slot button.active").parent();
				// if( options.rollDistace === 0 ){
				if ( $activeLi.is(':first-child') ) {
					el.find(".slot-prev").addClass("disabled").attr('aria-disabled',true); //PJTWAUS-1 : 20200115 modify
				}else{
					el.find(".slot-prev").attr('aria-disabled',false); //PJTWAUS-1 : 20200115 add
				}
				//if(Math.abs(options.rollDistace) === options.limit.max){
				if ( $activeLi.is(':last-child') ) {
					el.find(".slot-next").addClass("disabled").attr('aria-disabled',true); //PJTWAUS-1 : 20200115 modify
				}else{
					el.find(".slot-next").attr('aria-disabled',false); //PJTWAUS-1 : 20200115 add
				}
				/* // LGEGMC-243 20200528 */
			}
			function disabledMotion(tg, boundWidth){
				if( tg.hasClass("disabled") ){
					el.find(".slot-belt").addClass("banding");
					slotAnimate( (options.rollDistace + boundWidth) );
					setTimeout(function(){
						el.find(".slot-belt").removeClass("banding");
						slotAnimate( (options.rollDistace - boundWidth) );
						tg.addClass("disabled");	// prevent to termainate "disabled"
					}, 300);
				}
			}
			function preset(){
				el.find(".list-slot-item").attr({'aria-selected': false, 'tabindex': -1 }); /* LGEGMC-243 20200520 */
				el.find(".list-slot-item").first().addClass("active").attr({'aria-selected': true, 'tabindex': 0 }); /* LGEGMC-243 20200520 */
				calcHeight();
				slotAnimate(0);
				disableHandler();
				disabledrolling();
			}

			// event;
			function reflowEvent(){
				$(window).on("resize", function(){
					calcHeight();
					positioning(options.positionY);
					slotAnimate(options.rollDistace);
					disabledrolling();
				})
			}
			function UIEvent(){

				el.find(".slot-handler").on("click touch", "button", function(){
					var $this = $(this);
					var $parentLi = el.find(".category-list-slot .list-slot-item.active").parent();
					// adjust by case
					if( $this.hasClass("slot-prev")){
						
						/* LGEGMC-243 20200528 */
						//disabledMotion($this, options.itemMargin);
						if ( (!$parentLi.is(':first-child')) && (!$this.hasClass("disabled")) ) {
							$parentLi.prev().children().trigger('click').focus();
						}
						// options.rollDistace = -(Math.abs(options.rollDistace) - (options.avg*2));
						// if( options.rollDistace >= 0 ){
						// 	options.rollDistace = 0;
						// }
						/* // LGEGMC-243 20200528 */
					}
					if( $this.hasClass("slot-next")){
						
						/* LGEGMC-243 20200528 */
						/* disabledMotion($this, (-options.itemMargin)); */
						if ( (!$parentLi.is(':last-child')) && (!$this.hasClass("disabled")) ) {
							$parentLi.next().children().trigger('click').focus();
						}
						
						// options.rollDistace = -(Math.abs(options.rollDistace) + (options.avg*2));
						// if( Math.abs(options.rollDistace) >= options.limit.max ){
						// 	options.rollDistace = -(options.limit.max);
						// }
						/* // LGEGMC-243 20200528 */
					}
					//slotAnimate(options.rollDistace); /* // LGEGMC-243 20200528 */
					disabledrolling();
				});

				el.find(".category-list-slot").on("click touch", ".list-slot-item", function(){
					var $this = $(this);
					watchIndex($this);

					if(options.fullLength > options.showLength ){
						positioning(options.positionY);
						slotAnimate(options.rollDistace);
						disabledrolling();
					}
				});
				/* LGEGMC-243 20200520 */
				el.find(".category-list-slot").on("keydown", ".list-slot-item",function(e){
					var $parent = $(this).parent();
					if ((e.which === 37 || e.which === 38)) {
						e.preventDefault();
						if ( $parent.is(':first-child') ){
							$parent.siblings().last().children().trigger('click').focus();
						} else {
							$parent.prev().children().trigger('click').focus();
						}
						//console.log( $parent.is(':first-child'));
						//console.log('top');
					}
					if ((e.which === 39 || e.which === 40)) {
						e.preventDefault();
						if ( $parent.is(':last-child') ){
							$parent.siblings().first().children().trigger('click').focus();
						} else {
							$parent.next().children().trigger('click').focus();
						}
						//console.log( $parent.is(':last-child') );
						//console.log('bottom');
					}
				});
				/* // LGEGMC-243 20200520 */

				el.find(".tab-area").on("click touch", ".btn-tab", function(){
					var $this = $(this);
					watchIndex($this);

					if(options.fullLength > options.showLength ){
						positioning(options.positionY);
						slotAnimate(options.rollDistace);
						disabledrolling();
					}
				});
			}
		}
		component.init();
	}
	C0082();
});